'use strict';

const getters = {
  isWaitingForEvent: state => ({ interactionId, constraintNames }) => {
    if (state.waitingForEvent[interactionId] && constraintNames) {
      return state.waitingForEvent[interactionId].some(event => constraintNames.includes(event));
    } else {
      return !!state.waitingForEvent[interactionId];
    }
  },

  isWaitingForAgentState: state => agentId => {
    return state.customEvents.agentState.includes(agentId);
  },

  isWaitingForAgentTerminal: state => agentId => {
    return state.customEvents.agentTerminal.includes(agentId);
  },

  isWaitingForKpiCounter: state => {
    return state.customEvents.kpiCounter;
  }
};

export default {
  ...getters
};
